import { ReactElement } from 'react';
import { Stack } from '@zoopla-eng/zds-components/stack';
import { Box } from '@zoopla-eng/zds-components/box';
import { Hero } from '@zoopla-eng/zds-components/hero';
import { HelpLabel, SearchLabel } from './HousePricesSearch.styles';
import soldLong from './sold-long@4x.png';

const HeroLong = ({ children }: { children: ReactElement }) => (
    <Hero
        bg="$graphicBackgroundContrast"
        bleed="@S200"
        px={0}
        pt="$S200"
        pb="$S500"
    >
        <Box
            bpS200={{
                backgroundImage: `url(${soldLong})`,
                backgroundSize: 'cover'
            }}
            pb="$S200"
        >
            <Box
                width="100%"
                bpS200={{ width: '75%' }}
                bpM100={{ width: '60%' }}
                bpL100={{ width: '65%' }}
                p="$S400"
            >
                <Stack rowGap="$S100">
                    <SearchLabel htmlFor="location-search">
                        Search house prices by area
                    </SearchLabel>
                    {children}
                    <HelpLabel htmlFor="location-search">
                        Enter a location or post code
                    </HelpLabel>
                </Stack>
            </Box>
        </Box>
    </Hero>
);

export default HeroLong;
